<template>


  <div class="row" ref="firmeleMeleRoot"> <!-- <div class="row" v-if="$gate.isAdmin()"> -->

    <div class="toolbar py-6">
      <div class="container-fluid d-flex align-items-center">
        <div class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <span class="h-20px border-gray-200 border-start mx-3"></span>
          <ol class="breadcrumb breadcrumb-dot text-muted fs-6 fw-semibold">
            <li class="breadcrumb-item pe-3"><a @click="$router.go(-1)" style="cursor: pointer;" class="pe-3">Înapoi</a>
            </li>
            <li class="breadcrumb-item pe-3 text-muted">Listă firme</li>
          </ol>
          <span class="h-20px border-gray-200 border-start mx-3"></span>
        </div>
      </div>
    </div>


    <div class="content d-flex flex-column flex-column-fluid">
      <div class="container-fluid">
        <div class="card card-flush">
          <div class="card-header align-items-center py-5 gap-2 gap-md-5">
            <div class="card-title">
              <div class="d-flex align-items-center position-relative my-1" v-if="firma_actuala">
                Randul verde este pentru firma activa in prezent
              </div>
            </div>
            <div class="card-toolbar flex-row-fluid justify-content-end gap-5">
              <div class="input-group w-250px">
                .
              </div>
              <div class="w-100 mw-150px">
                .
              </div>
              <a class="btn btn-primary" @click="modalAdaugareFirma()">Adaugă firmă</a>
            </div>
          </div>
          <div class="card-body pt-0">
            <div id="tabel_firme_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
              <div class="table-responsive w-100">
                <table class="table table-striped table-row-bordered gy-5 gs-7 w-100" role="grid" id="tabel_firme">
                  <thead>
                    <tr class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                      <th class="w-5px pe-2 sorting" rowspan="1" colspan="1" aria-label="" style="width: 10.8906px;">
                      </th>
                      <th class="min-w-10px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1"
                        aria-label="ID Comanda: apasa pentru sortare crescatoare">ID</th>
                      <th class="min-w-175px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1"
                        aria-label="Client: apasa pentru sortare crescatoare">Firma</th>
                      <th class="min-w-30px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1"
                        aria-label="Stare: apasa pentru sortare crescatoare">Tip cont</th>
                      <th class="min-w-20px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1"
                        aria-label="Data adaugarii: apasa pentru sortare crescatoare">Adresa</th>
                      <th class="min-w-20px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1"
                        aria-label="Data adaugarii: apasa pentru sortare crescatoare">Activ</th>
                      <th class="min-w-100px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1"
                        aria-label="Data adaugarii: apasa pentru sortare crescatoare">Info Abonament</th>
                      <th class="min-w-100px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1" colspan="1"
                        aria-label="ANAF: apasa pentru sortare crescatoare">ANAF</th>
                      <th class="text-end min-w-100px sorting" tabindex="0" aria-controls="tabel_firme" rowspan="1"
                        colspan="1" aria-label="Data modificarii: apasa pentru sortare crescatoare">Data modificarii
                      </th>
                      <th class="text-end min-w-100px" tabindex="0" rowspan="1" colspan="1" aria-label="Actiuni">Actiuni
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="f in firme" :key="f.id" :class="f.id === firma_actuala ? 'bg-light-success' : ''">
                      <td>
                        <div class="form-check form-check-sm form-check-custom form-check-solid">
                          <input class="form-check-input" type="checkbox" value="1">
                        </div>
                      </td>
                      <td data-kt-ecommerce-order-filter="order_id">
                        <a class="text-gray-800 text-hover-primary fw-bold">{{ f.id }}</a>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
                            <a href="#">
                              <div v-if="f.firma.sigla" class="symbol-label">
                                <img :src="`/api/fisiere/sigla-firma/${f.id}`" alt="Sigla firmă"
                                  style="width: 100%; height: 100%; object-fit: contain;" />
                              </div>
                              <div v-else class="symbol-label fs-3 bg-light-warning text-warning">-</div>
                            </a>
                          </div>
                          <div class="ms-5">
                            <div class="ml-2">

                              <div class="text-dark-75 font-weight-bold line-height-sm">
                                <span class="fw-bold">{{ f.firma.denumire }}</span>
                              </div>
                              <a class="font-size-sm text-dark-50 text-hover-primary">{{ f.firma.cui }}</a>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="pe-0">
                        <div class="badge badge-success" v-if="f.drepturi == 1">Vizualizare</div>
                        <div class="badge badge-primary" v-if="f.drepturi == 2">Contabilitate</div>
                        <div class="badge badge-info" v-if="f.drepturi == 3">Editare</div>
                        <div class="badge badge-warning" v-if="f.drepturi == 4">Administrare</div>
                        <div class="badge badge-danger" v-if="f.drepturi == 5">Detinator</div>
                      </td>
                      <td>
                        <span class="fw-bold"><span class="font-weight-bold">{{ f.firma.adresa }}</span></span>
                      </td>
                      <td>
                        <span class="badge me-1" :class="getActivBadge(f.firma.activ).class"> {{
                          getActivBadge(f.firma.activ).text }} </span>
                        /
                        <span class="badge" :class="getStareFirmaBadge(f.firma.stare_firma).class"> {{
                          getStareFirmaBadge(f.firma.stare_firma).text }} </span>
                      </td>
                      <td>
                        <div class="d-flex align-items-center">
                          <div class="ms-5">
                            <div class="ml-2">
                              <div class="text-dark-75 font-weight-bold line-height-sm"
                                v-if="f.firma.date_abonament && f.firma.date_abonament.tip_abonament">
                                <span class="fw-bold">{{ f.firma.date_abonament.tip_abonament.denumire }}
                                  <span class="fw-bold"><span class="font-weight-bold text-danger"
                                      v-if="f.firma.date_abonament.activ == 0">Inactiv</span></span>
                                  <span class="fw-bold"><span class="font-weight-bold text-success"
                                      v-if="f.firma.date_abonament.activ == 1">Activ</span></span>
                                </span>
                              </div>
                              <a class="font-size-sm text-dark-50 text-hover-primary" v-if="f.firma.date_abonament">
                                {{ f.firma.date_abonament.inceput }} - {{ f.firma.date_abonament.expira }}
                              </a>
                              <span v-else class="text-muted">Fără abonament</span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span v-if="!f.anaf_data_final" class="text-danger fw-bold">Nu</span>
                        <span v-else-if="new Date(f.anaf_data_final) < new Date()" class="text-warning fw-bold">{{
                          $filters.formatDate(f.anaf_data_final) }}</span>
                        <span v-else class="text-success fw-bold">{{ $filters.formatDate(f.anaf_data_final) }}</span>
                      </td>
                      <td class="text-end">
                        <span class="fw-bold" v-if="f.firma.updated_at != null">{{
                          $filters.formatDate(f.firma.updated_at) }}</span>
                        <span class="fw-bold" v-if="f.firma.updated_at == null">{{
                          $filters.formatDate(f.firma.created_at) }}</span>
                      </td>
                      <td class="text-nowrap text-end">
                        <div class="d-inline-block" :ref="`rowMenuRef-${f.id}`">
                          <button type="button" class="btn btn-sm btn-primary rotate" data-kt-menu-trigger="click"
                            data-kt-menu-placement="bottom-end" data-kt-menu-offset="0, 6">
                            Acțiuni
                            <span class="fas fa-chevron-down rotate-180 ms-2 me-0"></span>
                          </button>
                          <div
                            class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-auto min-w-200 mw-300px"
                            data-kt-menu="true">
                            <div class="menu-item px-3">
                              <a href="#" class="menu-link px-3 d-flex align-items-center"
                                @click.prevent="modalEditareFirma(f.firma)">
                                <i class="fas fa-pencil-alt me-2 text-warning"></i>
                                <span>Editare</span>
                              </a>
                            </div>
                            <div class="menu-item px-3">
                              <a href="#" class="menu-link px-3 d-flex align-items-center"
                                @click.prevent="modalSeriiFirma(f.firma.id)">
                                <i class="fa fa-list-alt me-2 text-primary"></i>
                                <span>Serii</span>
                              </a>
                            </div>
                            <div class="menu-item px-3">
                              <a href="#" class="menu-link px-3 d-flex align-items-center"
                                @click.prevent="modalUtilizatoriFirma(f.firma.id)">
                                <i class="fa fa-users me-2 text-info"></i>
                                <span>Utilizatori</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal adaugare firmă -->
    <div class="modal fade" id="FirmaModal" tabindex="-1" aria-hidden="true" ref="modalFirma"
      aria-labelledby="FirmaModalLabel">
      <div class="modal-dialog modal-custom-width modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <template v-if="!editmode">
              <h3 class="modal-title" id="FirmaModalLabel">Adăugare firmă</h3>
            </template>
            <template v-else>
              <div class="d-flex justify-content-between align-items-center w-100">
                <span class="modal-title">Editează firmă</span>
                <span class="d-flex align-items-center">
                  <span class="me-2 text-muted fw-bold">Stare firmă:</span>
                  <span class="badge" :class="getStareFirmaBadge(form.stare_firma).class">
                    {{ getStareFirmaBadge(form.stare_firma).text }}
                  </span>
                </span>
              </div>
            </template>
            <!--begin::Close-->
            <button type="button" id="modalFirmaClose" class="btn-close" data-bs-dismiss="modal"
              aria-label="Close"></button>
            <!--end::Close-->
          </div>
          <div class="modal-body">
            <form onsubmit="return false;">
              <div class="container-fluid">
                <div id="adauga_caracteristica">
                  <div class="row">
                    <!-- Coloana 1 - Date firmă -->
                    <div class="col-md-4">
                      <h5>Date firmă</h5>
                      <hr>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <label class="form-label">Atribut fiscal</label>
                          <div class="input-group">
                            <span class="input-group-text" id="atrib-fiscal-addon">
                              <i class="ki-duotone ki-badge fs-2">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                                <span class="path4"></span>
                                <span class="path5"></span>
                              </i>
                            </span>
                            <input type="text" class="form-control" v-model="form.atrib_fiscal"
                              :class="{ 'is-invalid': form.errors.has('atrib_fiscal') }" placeholder="Atribut fiscal"
                              aria-describedby="atrib-fiscal-addon" />
                          </div>
                          <div class="invalid-feedback" v-if="form.errors.has('atrib_fiscal')"
                            v-html="form.errors.get('atrib_fiscal')"></div>
                        </div>
                        <div class="col-md-6">
                          <label class="form-label">CUI</label>
                          <div class="input-group">
                            <span class="input-group-text" id="cui-addon">
                              <i class="ki-duotone ki-briefcase fs-2">
                                <span class="path1"></span>
                                <span class="path2"></span>
                              </i>
                            </span>
                            <input type="text" class="form-control" v-model="form.cui"
                              :class="{ 'is-invalid': form.errors.has('cui') }" placeholder="CUI"
                              aria-describedby="cui-addon" />
                            <div class="invalid-feedback" v-if="form.errors.has('cui')" v-html="form.errors.get('cui')">
                            </div>

                            <span class="input-group-text" id="cui-search-addon" style="cursor:pointer"
                              @click="verificaCUI(form.cui)"
                              :class="{ 'bg-primary bg-opacity-10 text-primary': form.cui && form.cui.length > 0 }">
                              <i class="ki-duotone ki-magnifier fs-2"
                                :class="{ 'text-primary': form.cui && form.cui.length > 0 }">
                                <span class="path1"></span>
                                <span class="path2"></span>
                              </i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.denumire" class="form-control" id="denumire"
                          :class="{ 'is-invalid': form.errors.has('denumire') }" />
                        <label for="denumire">Denumire</label>
                        <div class="invalid-feedback" v-if="form.errors.has('denumire')"
                          v-html="form.errors.get('denumire')">
                        </div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.reg_com" class="form-control" id="reg_com"
                          :class="{ 'is-invalid': form.errors.has('reg_com') }" />
                        <label for="reg_com">Nr. Reg. Com.</label>
                        <div class="invalid-feedback" v-if="form.errors.has('reg_com')"
                          v-html="form.errors.get('reg_com')"></div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.cod_caen" class="form-control" id="cod_caen"
                          :class="{ 'is-invalid': form.errors.has('cod_caen') }" />
                        <label for="cod_caen">Cod CAEN</label>
                        <div class="invalid-feedback" v-if="form.errors.has('cod_caen')"
                          v-html="form.errors.get('cod_caen')">
                        </div>
                      </div>
                      <div class="input-group mb-5">
                        <span class="input-group-text">
                          <i class="ki-duotone ki-bank fs-2">
                            <span class="path1"></span>
                            <span class="path2"></span>
                          </i>
                        </span>
                        <input type="text" class="form-control" v-model="form.cap_soc"
                          :class="{ 'is-invalid': form.errors.has('cap_soc') }" placeholder="Capital social">
                        <span class="input-group-text">LEI</span>
                      </div>
                      <div class="invalid-feedback" v-if="form.errors.has('cap_soc')"
                        v-html="form.errors.get('cap_soc')"></div>
                      <div class="form-check form-switch mb-3">
                        <input class="form-check-input" type="checkbox" v-model="form.scp_tva" id="scp_tva">
                        <label class="form-check-label" for="scp_tva">SCP TVA</label>
                      </div>
                      <div class="form-check form-switch mb-3">
                        <input class="form-check-input" type="checkbox" v-model="form.activ" id="activ">
                        <label class="form-check-label" for="activ">Activ</label>
                      </div>
                      <div class="form-floating mb-3" v-if="$gate.isAdmin()">
                        <select class="form-select" id="stare_firma" v-model.number="form.stare_firma">
                          <option :value="0">În așteptare</option>
                          <option :value="1">În verificare</option>
                          <option :value="2">Activă</option>
                          <option :value="10">Dezactivată</option>
                          <option :value="11">Blocat</option>
                        </select>
                        <label for="stare_firma">Stare firmă</label>
                      </div>
                      <div class="mb-3">
                        <label for="sigla" class="form-label">Logo firmă</label>
                        <input class="form-control" type="file" name="sigla" id="sigla" @change="handleFile">
                      </div>
                      <div class="mt-2">
                        <img v-if="previewUrl" :src="previewUrl" alt="Sigla firmei"
                          style="width: 250px; height: 250px; object-fit: contain; margin-bottom: 10px;" />
                      </div>
                    </div>
                    <!-- Coloana 2 - Adrese și locație -->
                    <div class="col-md-4">
                      <h5>Adrese și locație</h5>
                      <hr>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.adresa" class="form-control" id="adresa"
                          :class="{ 'is-invalid': form.errors.has('adresa') }" />
                        <label for="adresa">Adresă</label>
                        <div class="invalid-feedback" v-if="form.errors.has('adresa')"
                          v-html="form.errors.get('adresa')"></div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.strada" class="form-control" id="strada"
                          :class="{ 'is-invalid': form.errors.has('strada') }" />
                        <label for="strada">Strada</label>
                        <div class="invalid-feedback" v-if="form.errors.has('strada')"
                          v-html="form.errors.get('strada')"></div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.cod_postal" class="form-control" id="cod_postal"
                          :class="{ 'is-invalid': form.errors.has('cod_postal') }" />
                        <label for="cod_postal">Cod poștal</label>
                        <div class="invalid-feedback" v-if="form.errors.has('cod_postal')"
                          v-html="form.errors.get('cod_postal')">
                        </div>
                      </div>
                      <div class="mb-3">
                        <label for="tara" class="form-label">Țara</label>
                        <Select2 id="tara" v-model="form.tara" :options="tari" :settings="setari_select2"
                          @select="incarcaJudete(form.tara)" class="w-100" />
                      </div>
                      <div class="mb-3">
                        <label for="judet" class="form-label">Județ</label>
                        <Select2 id="judet" v-model="form.judet" :options="judete" :settings="setari_select2"
                          @select="incarcaLocalitati(form.judet)" class="w-100" />
                      </div>
                      <div class="mb-3">
                        <label for="localitate" class="form-label">Localitate</label>
                        <Select2 id="localitate" v-model="form.localitate" :options="localitati"
                          :settings="setari_select2" class="w-100" />
                      </div>
                    </div>
                    <!-- Coloana 3 - Date facturare -->
                    <div class="col-md-4">
                      <h5>Date facturare</h5>
                      <hr>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.telefon_facturare" class="form-control" id="telefon_facturare"
                          :class="{ 'is-invalid': form.errors.has('telefon_facturare') }" />
                        <label for="telefon_facturare">Telefon facturare</label>
                        <div class="invalid-feedback" v-if="form.errors.has('telefon_facturare')"
                          v-html="form.errors.get('telefon_facturare')"></div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.fax_facturare" class="form-control" id="fax_facturare"
                          :class="{ 'is-invalid': form.errors.has('fax_facturare') }" />
                        <label for="fax_facturare">Fax facturare</label>
                        <div class="invalid-feedback" v-if="form.errors.has('fax_facturare')"
                          v-html="form.errors.get('fax_facturare')"></div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="email" v-model="form.email" class="form-control" id="email"
                          :class="{ 'is-invalid': form.errors.has('email') }" />
                        <label for="email">E-Mail</label>
                        <div class="invalid-feedback" v-if="form.errors.has('email')" v-html="form.errors.get('email')">
                        </div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.web" class="form-control" id="web"
                          :class="{ 'is-invalid': form.errors.has('web') }" />
                        <label for="web">Web</label>
                        <div class="invalid-feedback" v-if="form.errors.has('web')" v-html="form.errors.get('web')">
                        </div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.telefon" class="form-control" id="telefon"
                          :class="{ 'is-invalid': form.errors.has('telefon') }" />
                        <label for="telefon">Telefon</label>
                        <div class="invalid-feedback" v-if="form.errors.has('telefon')"
                          v-html="form.errors.get('telefon')"></div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.fax" class="form-control" id="fax"
                          :class="{ 'is-invalid': form.errors.has('fax') }" />
                        <label for="fax">Fax</label>
                        <div class="invalid-feedback" v-if="form.errors.has('fax')" v-html="form.errors.get('fax')">
                        </div>
                      </div>
                      <h5 class="mt-4">Reprezentant legal</h5>
                      <hr>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.nume" class="form-control" id="nume"
                          :class="{ 'is-invalid': form.errors.has('nume') }" />
                        <label for="nume">Nume</label>
                        <div class="invalid-feedback" v-if="form.errors.has('nume')" v-html="form.errors.get('nume')">
                        </div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.ci" class="form-control" id="ci"
                          :class="{ 'is-invalid': form.errors.has('ci') }" />
                        <label for="ci">CI</label>
                        <div class="invalid-feedback" v-if="form.errors.has('ci')" v-html="form.errors.get('ci')"></div>
                      </div>
                      <div class="form-floating mb-3">
                        <input type="text" v-model="form.cnp" class="form-control" id="cnp"
                          :class="{ 'is-invalid': form.errors.has('cnp') }" />
                        <label for="cnp">CNP</label>
                        <div class="invalid-feedback" v-if="form.errors.has('cnp')" v-html="form.errors.get('cnp')">
                        </div>
                      </div>
                    </div>
                    <!-- Date bancare -->
                    <div class="col-md-6">
                      <h5 class="mt-4">Date bancare</h5>
                      <hr>
                      <div class="mb-3">
                        <label class="form-label">Conturi bancare</label>
                        <div class="mb-2"></div>
                        <div v-for="(cont, index) in form.conturi_bancare" :key="index" class="border p-3 rounded mb-2">
                          <div class="row align-items-center">
                            <div class="col-md-3">
                              <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" v-model="cont.vizibil"
                                  :id="'vizibil_' + index">
                                <label class="form-check-label" :for="'vizibil_' + index">Vizibil</label>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-floating">
                                <input type="text" class="form-control" v-model="cont.iban" :id="'iban_' + index">
                                <label :for="'iban_' + index">IBAN</label>
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="form-floating">
                                <input type="text" class="form-control" v-model="cont.banca" :id="'banca_' + index">
                                <label :for="'banca_' + index">Banca</label>
                              </div>
                            </div>
                            <div class="col-md-1 d-flex justify-content-end">
                              <button type="button" class="btn btn-sm btn-danger" @click="stergeCont(index)">×</button>
                            </div>
                          </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-primary mt-2" @click="adaugaCont">Adaugă
                          cont</button>
                      </div>
                    </div>
                    <!-- Puncte lucru -->
                    <div class="col-md-6">
                      <h5 class="mt-4">Puncte lucru</h5>
                      <hr>
                      <div class="mb-3">
                        <label class="form-label">Puncte lucru</label>
                        <div class="mb-2"></div>
                        <div v-for="(punct, index) in form.puncte_lucru" :key="index" class="border p-3 rounded mb-2">
                          <div class="row align-items-center mb-2">
                            <div class="col-md-3">
                              <div class="form-check form-switch">
                                <input class="form-check-input" type="checkbox" v-model="punct.vizibil"
                                  :id="'pl_vizibil_' + index">
                                <label class="form-check-label" :for="'pl_vizibil_' + index">Vizibil</label>
                              </div>
                            </div>
                            <div class="col-md-9">
                              <div class="form-floating">
                                <input type="text" class="form-control" v-model="punct.adresa"
                                  :id="'pl_adresa_' + index">
                                <label :for="'pl_adresa_' + index">Adresă</label>
                              </div>
                            </div>
                          </div>
                          <div class="row align-items-center mb-2">
                            <div class="col-md-6">
                              <div class="form-floating">
                                <input type="text" class="form-control" v-model="punct.telefon_contact"
                                  :id="'pl_telefon_' + index">
                                <label :for="'pl_telefon_' + index">Telefon contact</label>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-floating">
                                <input type="text" class="form-control" v-model="punct.fax" :id="'pl_fax_' + index">
                                <label :for="'pl_fax_' + index">Fax</label>
                              </div>
                            </div>
                          </div>
                          <div class="row align-items-center">
                            <div class="col-md-11">
                              <div class="form-floating">
                                <input type="text" class="form-control" v-model="punct.persoana_contact"
                                  :id="'pl_persoana_' + index">
                                <label :for="'pl_persoana_' + index">Persoană contact</label>
                              </div>
                            </div>
                            <div class="col-md-1 d-flex justify-content-end align-items-start">
                              <button type="button" class="btn btn-sm btn-danger mt-2"
                                @click="stergePunct(index)">×</button>
                            </div>
                          </div>
                        </div>
                        <button type="button" class="btn btn-sm btn-primary mt-2" @click="adaugaPunct">Adaugă
                          punct</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Închide</button>
            <button @click="actualizeazaFirma(this.form.id)" v-show="editmode" type="submit"
              class="btn btn-success">Modifică</button>
            <button @click="conecteazaAnaf(this.form.id)" v-show="editmode" type="button"
              class="btn btn-outline-primary ms-2">
              🔐 Conectează ANAF
            </button>
            <button @click="refreshAnafToken(this.form.id)" v-show="editmode" type="button"
              class="btn btn-outline-warning ms-2">
              ♻️ Refresh Token
            </button>

            <button v-show="!editmode" @click="adaugaFirma()" type="submit" class="btn btn-primary">Adaugă</button>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- Modal Serii firmă -->
  <div class="modal fade" id="SeriiFirmaModal" tabindex="-1" aria-hidden="true" ref="modalSerii"
    aria-labelledby="SeriiFirmaModalLabel">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="SeriiFirmaModalLabel">Serii firmă</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <table class="table table-bordered table-striped align-middle">
            <thead class="table-light fw-bold">
              <tr>
                <th>ID</th>
                <th>Tip Serie</th>
                <th>Serie</th>
                <th>Nr. Început</th>
                <th>Descriere</th>
                <th>Acțiuni</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="serie in lista_serii" :key="serie.id">
                <td>{{ serie.id }}</td>
                <td>{{ tip_serie_labels[serie.tip_serie] || serie.tip_serie }}</td>
                <td>{{ serie.serie }}</td>
                <td>{{ serie.numar_inceput || 1 }}</td>
                <td>{{ serie.descriere }}</td>
                <td>
                  <button class="btn btn-sm btn-light-primary me-2"
                    @click="buton_editeazaSeria(serie)">Editează</button>
                  <button class="btn btn-sm btn-light-danger"
                    @click="stergeSeria(serie.id_firma, serie.id)">Șterge</button>
                </td>
              </tr>
            </tbody>
          </table>

          <hr>
          <div class="card shadow-sm mt-10">
            <div class="card-body">
              <h5 class="mb-4">Adaugă Serie Nouă</h5>

              <div v-if="eroare_add_serie"
                class="alert alert-dismissible bg-danger d-flex flex-column flex-sm-row p-5 mb-10">
                <i class="ki-duotone ki-information-2 fs-2hx text-light me-4 mb-5 mb-sm-0">
                  <span class="path1"></span><span class="path2"></span><span class="path3"></span>
                </i>

                <div class="d-flex flex-column text-light pe-0 pe-sm-10">
                  <h4 class="mb-2">Eroare</h4>
                  <span>{{ eroare_add_serie }}</span>
                </div>

                <button type="button"
                  class="position-absolute position-sm-relative m-2 m-sm-0 top-0 end-0 btn btn-icon ms-sm-auto"
                  @click="eroare_add_serie = null">
                  <i class="ki-duotone ki-cross fs-1 text-light">
                    <span class="path1"></span><span class="path2"></span>
                  </i>
                </button>
              </div>

              <div class="row mb-5">
                <label class="col-lg-3 col-form-label fw-semibold">Tip Serie</label>
                <div class="col-lg-9">
                  <select v-model="form_serii.tip_serie" class="form-select">
                    <option v-for="(label, id) in tip_serie_labels" :key="id" :value="parseInt(id)">
                      {{ label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mb-5">
                <label class="col-lg-3 col-form-label fw-semibold">Număr Început</label>
                <div class="col-lg-9">
                  <input type="number" v-model="form_serii.numar_inceput" class="form-control"
                    placeholder="Ex: 1 sau 100" min="1" />
                </div>
              </div>

              <div class="row mb-5">
                <label class="col-lg-3 col-form-label fw-semibold">Serie</label>
                <div class="col-lg-9">
                  <input type="text" v-model="form_serii.serie" class="form-control" placeholder="Ex: FCT2025" />
                </div>
              </div>

              <div class="row mb-5">
                <label class="col-lg-3 col-form-label fw-semibold">Descriere</label>
                <div class="col-lg-9">
                  <input type="text" v-model="form_serii.descriere" class="form-control"
                    placeholder="Descriere opțională" />
                </div>
              </div>

              <div class="text-end">
                <button class="btn btn-success" @click="adaugaSerieNoua(form_serii.id_firma)"
                  v-if="editmode_serii == false">Adaugă</button>
                <button class="btn btn-secondary" @click="anuleaza_editareSerie()"
                  v-if="editmode_serii == true">Anuleaza
                  editare</button>
                <button class="btn btn-success" @click="editeazaSerie(form_serii.id_firma, form_serii.id)"
                  v-if="editmode_serii == true">Editează</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!-- Modal Utilizatori firmă -->
  <div class="modal fade" id="UtilizatoriFirmaModal" tabindex="-1" aria-hidden="true" ref="modalUtilizatori"
    aria-labelledby="UtilizatoriFirmaModalLabel">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="UtilizatoriFirmaModalLabel">Utilizatori firmă</h3>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div>
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="mb-0">Utilizatori</h5>
              <span class="text-muted small">{{ edit_utilizatori.length }} înregistrați</span>
            </div>
            <div class="text-end mb-3">
              <button class="btn btn-sm btn-primary" v-if="!show_add_user_form" @click="openAddUserForm">Adaugă
                utilizator</button>
            </div>
            <div v-if="can_invite_user" class="col-md-12 text-end mt-3">
              <button class="btn btn-danger" @click.prevent>Invită utilizator</button>
            </div>

            <div v-if="show_add_user_form" class="card border p-3 mb-3">
              <div class="row g-3 align-items-end">
                <div class="col-md-6">
                  <label class="form-label">Email</label>
                  <input type="email" class="form-control" v-model="add_user_email" placeholder="user@exemplu.ro">
                </div>
                <div class="col-md-4">
                  <label class="form-label">Tip cont</label>
                  <select class="form-select" v-model.number="add_user_role">
                    <option v-for="opt in role_options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
                <div class="col-md-12 text-end">
                  <button class="btn btn-light me-2" @click="cancelAddUserForm">Cancel</button>
                  <button class="btn btn-primary" @click="adaugaUtilizatorFirma"
                    :disabled="!add_user_email || !add_user_role">Adaugă</button>
                </div>
              </div>
            </div>
            <div v-if="edit_utilizatori && edit_utilizatori.length">
              <div class="list-group list-group-flush">
                <div v-for="u in edit_utilizatori" :key="u.id"
                  class="list-group-item d-flex align-items-center justify-content-between py-3">
                  <div class="d-flex align-items-center gap-3">
                    <div
                      class="symbol symbol-circle symbol-35px bg-light d-flex align-items-center justify-content-center">
                      <i class="fas fa-user"></i>
                    </div>
                    <div class="d-flex flex-column">
                      <span class="fw-bold">{{ u.name }}</span>
                      <span class="text-muted small">{{ u.email }}</span>
                    </div>
                  </div>
                  <span :class="firmRoleBadgeClass(u.drepturi)" class="badge">{{ firmRoleLabel(u.drepturi) }}</span>
                </div>
              </div>
            </div>
            <div v-else class="text-muted">Niciun utilizator asociat.</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Închide</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import moment from "moment";
import { Modal } from 'bootstrap'
import { getStareFirmaBadge } from '../../consts/firmaStatus'
//import vue2Dropzone from 'vue2-dropzone'
//import 'vue2-dropzone/dist/vue2Dropzone.min.css'
//import VueDatepickerUi from 'vue-datepicker-ui'
//import 'vue-datepicker-ui/lib/vuedatepickerui.css';



import Form from 'vform'
export default {
  components: {
    moment: moment,
  },
  data() {

    return {

      setari_select2: {
        theme: 'bootstrap-5',
        placeholder: "Selectează din listă",
        width: "100%",
        dropdownParent: null
      },

      firma_actuala: '',
      firme: [],
      tari: [],
      judete: [],
      localitati: [],
      lista_serii: [],
      eroare_add_serie: null,
      editmode: false,
      editmode_serii: false,
      firma_selectata_utilizatori: null,
      edit_utilizatori: [],
      show_add_user_form: false,
      add_user_email: '',
      add_user_role: null,
      role_options: [
        { value: 5, label: 'Deținător' },
        { value: 4, label: 'Administrator' },
        { value: 3, label: 'Editor' },
        { value: 2, label: 'Operator' },
        { value: 1, label: 'Vizualizare' },
      ],
      can_invite_user: false, // 👈 flag pentru butonul "Invită utilizator"

      seriiFirma: [],
      formSerie: {
        denumire: '',
        tip_document: '',
        serie: '',
        numar_curent: 1
      },

      form: Form.make({
        id: '',
        cui: '',
        denumire: '',
        adresa: '',
        reg_com: '',
        telefon: '',
        fax: '',
        cod_caen: '',
        scp_tva: '',
        stare_firma: 0,
        activ: true,
        atrib_fiscal: '',
        adrese: '',
        judet: '',
        tara: '',
        localitate: '',
        strada: '',
        cod_postal: '',
        puncte_lucru: [],
        conturi_bancare: [],
        cap_soc: '',
        telefon_facturare: '',
        fax_facturare: '',
        email: '',
        web: '',
        nume: '',
        ci: '',
        cnp: '',
        sigla: '',
      }),
      tip_serie_labels: {
        1: 'Factură',
        2: 'Factură Proformă',
        3: 'Chitanță',
        4: 'Dispoziție încasare',
        5: 'Dispoziție plată',
        6: 'Proces verbal compensare'
      },
      form_serii: Form.make({
        id: '',
        tip_serie: 1,
        serie: '',
        descriere: '',
        numar_inceput: 1,
        created_at: '',
        updated_at: '',
        id_firma: '',
      }),
      form_sigla: new Form({
        sigla: null
      }),
      previewUrl: null,
      // track open fallback menus (wrapper -> menu element)
      _openFallbackMenus: [],
      _menuDismissBound: false,
    }
  },
  methods: {
    async verificaCUI(cui) {
      if (!cui) {
        toast && toast.fire
          ? toast.fire({
            icon: 'error',
            title: 'Introdu un CUI valid.',
          })
          : console.warn('Introdu un CUI valid.');
        return;
      }

      try {
        const response = await axios.post('/api/efactura/verifica-cui/utilizator', {
          cui,
          force_anaf: this.editmode // Only force fresh ANAF data if we're in edit mode
        });
        const data = response.data || {};

        if (data.status === 'exists' || data.status === 'preview') {
          const firma = data.client || data.firma || {};

          this.form.atrib_fiscal = firma.atrib_fiscal || this.form.atrib_fiscal || 'RO';
          this.form.cui = firma.cui ? String(firma.cui) : '';
          this.form.denumire = firma.denumire || '';
          this.form.reg_com = firma.reg_com || '';

          this.form.adresa = firma.adresa || '';
          this.form.strada = firma.strada || '';
          this.form.cod_postal = firma.cod_postal || '';

          // id-uri pentru Select2
          if (firma.tara) {
            this.form.tara = String(firma.tara);
            this.incarcaTari();              // ca fallback, populăm lista
            this.incarcaJudete(this.form.tara);
          }

          if (firma.judet) {
            this.form.judet = String(firma.judet);
            this.incarcaLocalitati(this.form.judet);
          }

          if (firma.localitate) {
            this.form.localitate = String(firma.localitate);
          }

          this.form.telefon = firma.telefon || '';
          this.form.scp_tva = firma.scp_tva === 1 || firma.scp_tva === true;
          this.form.cod_caen = firma.cod_caen || '';

          if (toast && toast.fire) {
            toast.fire({
              icon: 'success',
              title: data.message || 'Date preluate din ANAF.',
            });
          }
        } else {
          toast && toast.fire
            ? toast.fire({
              icon: 'warning',
              title: 'CUI-ul nu a fost găsit în ANAF.',
            })
            : console.warn('CUI-ul nu a fost găsit în ANAF.');
        }
      } catch (error) {
        console.error(error);
        toast && toast.fire
          ? toast.fire({
            icon: 'error',
            title: 'Eroare la verificarea CUI.',
          })
          : console.error('Eroare la verificarea CUI.');
      }
    },
    getStareFirmaBadge,
    getActivBadge(activ) {
      return {
        class: activ === 1 ? 'badge-success' : 'badge-danger',
        text: activ === 1 ? 'Da' : 'Nu'
      }
    },
    initKTMenus() {
      try {
        const container = this.$refs?.firmeleMeleRoot;
        const scope = (container && typeof container.querySelectorAll === 'function') ? container : document;
        if (!scope) return;

        const menus = scope.querySelectorAll('[data-kt-menu="true"]');
        menus.forEach((el) => {
          if (el.getAttribute('data-kt-menu-initialized') === '1') return;

          if (typeof window.KTMenu === 'function') {
            try { new window.KTMenu(el); } catch (_) { }
          }

          if (window.KTMenu && typeof window.KTMenu.createInstances === 'function') {
            try { window.KTMenu.createInstances(el); } catch (_) { }
          }

          // Mark initialized only if a real KTMenu instance exists
          try {
            if (window.KTMenu && typeof window.KTMenu.getInstance === 'function') {
              const inst = window.KTMenu.getInstance(el)
              if (inst) {
                el.setAttribute('data-kt-menu-initialized', '1')
              }
            }
          } catch (_) { }
        });
      } catch (e) {
        console.warn('KTMenu scoped init failed:', e);
      }
      // Asigurăm funcționalitate minimă dacă KTMenu nu a atașat evenimentele
      this.fallbackInitRowMenus()
    },
    // Bind one-time global handlers to close any fallback menus on outside click / ESC
    bindGlobalMenuDismiss() {
      if (this._menuDismissBound) return
      this._menuDismissBound = true
      // Use capture phase to catch events before they are stopped
      this._docClickHandler = (e) => {
        try {
          if (!this._openFallbackMenus || !this._openFallbackMenus.length) return
          // Close all menus where click is outside their wrapper
          const toClose = []
          this._openFallbackMenus.forEach(({ wrapper, menuEl }) => {
            if (!wrapper || !menuEl) return
            if (!wrapper.contains(e.target)) {
              toClose.push({ wrapper, menuEl })
            }
          })
          toClose.forEach(({ menuEl }) => {
            menuEl.classList.remove('show')
            menuEl.style.display = 'none'
          })
          // keep only still-open ones
          this._openFallbackMenus = this._openFallbackMenus.filter(({ wrapper }) => wrapper && wrapper.contains(e.target))
        } catch (err) { console.warn('global dismiss click handler error:', err) }
      }
      document.addEventListener('click', this._docClickHandler, true)

      this._escKeyHandler = (e) => {
        if (e.key === 'Escape') {
          try {
            if (!this._openFallbackMenus || !this._openFallbackMenus.length) return
            this._openFallbackMenus.forEach(({ menuEl }) => {
              menuEl.classList.remove('show')
              menuEl.style.display = 'none'
            })
            this._openFallbackMenus = []
          } catch (err) { console.warn('global dismiss esc handler error:', err) }
        }
      }
      document.addEventListener('keydown', this._escKeyHandler, true)
    },
    // Helper to register a menu as open (used by fallback)
    _registerOpenFallbackMenu(wrapper, menuEl) {
      if (!this._openFallbackMenus) this._openFallbackMenus = []
      const exists = this._openFallbackMenus.some((m) => m.menuEl === menuEl)
      if (!exists) this._openFallbackMenus.push({ wrapper, menuEl })
    },
    // Fallback for row action menus if KTMenu didn't bind
    fallbackInitRowMenus() {
      try {
        const scope = this.$refs?.firmeleMeleRoot || document
        const triggers = scope.querySelectorAll('[data-kt-menu-trigger]')
        triggers.forEach((t) => {
          // find the menu element that belongs to this trigger (same wrapper)
          // our markup: <div class="d-inline-block"><button data-kt-menu-trigger ...></button><div class="menu" data-kt-menu="true">...</div></div>
          const wrapper = t.closest('div')
          if (!wrapper) return
          let menuEl = null
          // prefer immediate sibling .menu
          if (t.nextElementSibling && t.nextElementSibling.matches && t.nextElementSibling.matches('.menu[data-kt-menu="true"]')) {
            menuEl = t.nextElementSibling
          } else if (wrapper.querySelector) {
            menuEl = wrapper.querySelector(':scope > .menu[data-kt-menu="true"]')
          }
          if (!menuEl) return

          // If KTMenu already created an instance (or we marked it), skip
          if (menuEl.getAttribute('data-kt-menu-initialized') === '1') return
          try {
            if (window.KTMenu && typeof window.KTMenu.getInstance === 'function') {
              const inst = window.KTMenu.getInstance(menuEl)
              if (inst) { menuEl.setAttribute('data-kt-menu-initialized', '1'); return }
            }
          } catch (_) { }

          // Manual dropdown behavior (click to toggle)
          wrapper.style.position = wrapper.style.position || 'relative'
          menuEl.style.position = 'absolute'
          const place = () => {
            const h = t.offsetHeight || 0
            menuEl.style.top = (h + 6) + 'px'
            menuEl.style.right = '0'
            menuEl.style.left = 'auto'
            menuEl.style.minWidth = menuEl.style.minWidth || '200px'
            menuEl.style.zIndex = '1050'
          }
          const show = () => {
            place()
            menuEl.classList.add('show')
            menuEl.style.display = 'block'
            this.bindGlobalMenuDismiss()
            this._registerOpenFallbackMenu(wrapper, menuEl)
          }
          const hide = () => {
            menuEl.classList.remove('show')
            menuEl.style.display = 'none'
            if (this._openFallbackMenus && this._openFallbackMenus.length) {
              this._openFallbackMenus = this._openFallbackMenus.filter((m) => m.menuEl !== menuEl)
            }
          }
          const toggle = (e) => { e && e.preventDefault(); (menuEl.classList.contains('show') ? hide() : show()) }

          // Prevent duplicated listeners by cloning trigger
          const newT = t.cloneNode(true)
          t.parentNode.replaceChild(newT, t)
          newT.addEventListener('click', toggle)

          // mark as initialized to avoid re-binding
          menuEl.setAttribute('data-kt-menu-initialized', '1')
        })
      } catch (e) {
        console.warn('fallbackInitRowMenus failed:', e)
      }
    },
    initDataTable() {
      try {
        const scope = this.$refs?.firmeleMeleRoot || document;
        const tableEl = scope.querySelector ? scope.querySelector('#tabel_firme') : document.getElementById('tabel_firme');
        if (!tableEl) return;

        // Safety: ensure it's destroyed if it still exists (though we try to destroy before update)
        if ($.fn.DataTable && $.fn.DataTable.isDataTable(tableEl)) {
          $(tableEl).DataTable().destroy();
        }

        this.$nextTick(() => {
          // ensure DOM is painted
          setTimeout(() => {
            if (!$.fn.DataTable) return;
            // Double check validation before init
            if (!$.fn.DataTable.isDataTable(tableEl)) {
              const table = $(tableEl).DataTable({
                order: [[1, 'desc']],
                dom: 'Bfrtip',
                buttons: [],
                language: {
                  url: 'https://cdn.datatables.net/plug-ins/1.11.3/i18n/ro.json'
                }
              });
              // rebind KT menus after DT rebuilds the DOM
              this.initKTMenus();
              // Call fallback on draw/redraw
              table.on('draw.dt', () => {
                this.$nextTick(() => this.initKTMenus());
                this.$nextTick(() => this.fallbackInitRowMenus())
              });
            }
          }, 0);
        });
      } catch (e) {
        console.warn('DataTable init failed:', e);
      }
    },
    async incarcaUtilizatoriFirme(id) {
      try {
        const response = await axios.get(`/api/cont/incarcaUtilizatoriFirma/${id}`);
        this.edit_utilizatori = Array.isArray(response.data?.utilizatori) ? response.data.utilizatori : [];
        return response;
      } catch (error) {
        const msg = error.response?.data?.message || 'Nu s-au putut încărca utilizatorii.';
        console.error('Eroare la încărcarea utilizatorilor firmei:', error.response?.data || error.message);
        this.edit_utilizatori = [];
        throw new Error(msg);
      }
    },
    async modalUtilizatoriFirma(id) {
      this.firma_selectata_utilizatori = id;
      this.edit_utilizatori = [];
      this.show_add_user_form = false;
      this.add_user_email = '';
      this.add_user_role = null;
      try {
        await this.incarcaUtilizatoriFirme(id);
        (this._modalUtilizatori || (this.$refs.modalUtilizatori && Modal.getOrCreateInstance(this.$refs.modalUtilizatori)))?.show();
      } catch (e) {
        const msg = e?.message || 'Nu s-au putut încărca utilizatorii.';
        toast && toast.fire && toast.fire({ icon: 'error', title: msg });
      }
    },
    openAddUserForm() {
      this.show_add_user_form = true;
    },
    cancelAddUserForm() {
      this.show_add_user_form = false;
      this.add_user_email = '';
      this.add_user_role = null;
      this.can_invite_user = false; // 👈 resetăm
    },
    async adaugaUtilizatorFirma() {
      try {
        const payload = {
          firma_id: this.firma_selectata_utilizatori,
          email: this.add_user_email,
          drepturi: Number(this.add_user_role)
        };
        await axios.post('/api/cont/adaugaUtilizatorFirma', {
          firma_id: this.firma_selectata_utilizatori,
          email: this.add_user_email,
          drepturi: Number(this.add_user_role),
        });
        await this.incarcaUtilizatoriFirme(this.firma_selectata_utilizatori);

        this.cancelAddUserForm();
        toast && toast.fire && toast.fire({ icon: 'success', title: 'Utilizator adăugat (simulat). Vom conecta API-ul.' });
      }
      catch (error) {
        console.error('Eroare la adăugarea utilizatorului:', error.response?.data || error.message);
        const msg = error.response?.data?.message || 'Eroare la adăugare.';

        if (msg.includes('nu există')) {
          this.can_invite_user = true; // 👈 activăm butonul de invitație
        } else {
          this.can_invite_user = false;
        }

        toast && toast.fire && toast.fire({ icon: 'error', title: msg });
      }
    },
    firmRoleLabel(drepturi) {
      const d = Number(drepturi || 0);
      if (d >= 5) return 'Deținător';
      if (d === 4) return 'Administrator';
      if (d === 3) return 'Editor';
      if (d === 2) return 'Operator';
      if (d === 1) return 'Vizualizare';
      return '—';
    },
    firmRoleBadgeClass(drepturi) {
      const d = Number(drepturi || 0);
      if (d >= 5) return 'badge badge-light-success';
      if (d === 4) return 'badge badge-light-danger';
      if (d === 3) return 'badge badge-light-info';
      if (d === 2) return 'badge badge-light-warning';
      if (d === 1) return 'badge badge-light-secondary';
      return 'badge badge-light';
    },
    handleFile(event) {
      const file = event.target.files[0];
      this.form_sigla.sigla = file;
      //console.log(this.form_sigla.sigla);
      //console.log(event);
    },
    conecteazaAnaf(id_firma) {
      const redirectUrl = `/api/anaf/connect/${id_firma}`;
      window.open(redirectUrl, '_blank');
    },
    refreshAnafToken(id_firma) {
      axios
        .post(`/api/anaf/refresh/${id_firma}`)
        .then((response) => {
          console.log('✅ Token reîmprospătat:', response.data);
          const msg = response.data?.message || 'Token reîmprospătat cu succes!';
          Swal.fire({ icon: 'success', title: 'Succes!', text: msg });
        })
        .catch((error) => {
          console.error('❌ Eroare la reîmprospătare token:', error.response?.data || error.message);
          const msg = error.response?.data?.message || 'Eroare la reîmprospătare token.';
          Swal.fire({ icon: 'error', title: 'Eroare!', text: msg });
        });
    },
    incarcaFirmeleMele() {
      axios.get("/api/cont/incarcaFirme")
        .then((response) => {
          // Destroy existing table BEFORE updating data to avoid Vue/jQuery conflict
          if ($.fn.DataTable && $.fn.DataTable.isDataTable('#tabel_firme')) {
            $('#tabel_firme').DataTable().destroy();
          }

          this.firme = response.data.firme;
          this.firma_actuala = response.data.firma_actuala;

          this.$nextTick(() => {
            this.initDataTable();
          });
        });
    },
    modalAdaugareFirma() {
      this.editmode = false;
      this.form.reset();
      this.form.tara = '';
      this.form.judet = '';
      this.form.localitate = '';
      this.form.stare_firma = 0;
      this.form.conturi_bancare = [];
      this.form.puncte_lucru = [];
      this.form_sigla.sigla = null;
      this.previewUrl = null;
      this.incarcaTari();
      this.judete = [];
      this.localitati = [];
      (this._modalFirma || (this.$refs.modalFirma && Modal.getOrCreateInstance(this.$refs.modalFirma)))?.show();
    },
    modalSeriiFirma(id) {
      this.form_serii.reset();
      this.form_serii.tip_serie = 1;
      this.form_serii.numar_inceput = 1;
      this.editmode_serii = false;
      this.incarcaSeriiFirma(id);
      this.form_serii.id_firma = id;
      (this._modalSerii || (this.$refs.modalSerii && Modal.getOrCreateInstance(this.$refs.modalSerii)))?.show();
    },
    buton_editeazaSeria(serie) {
      this.form_serii.fill(serie);
      this.editmode_serii = true;
    },
    anuleaza_editareSerie() {
      this.form_serii.reset();
      this.form_serii.tip_serie = 1;
      this.form_serii.numar_inceput = 1;
      this.editmode_serii = false;
    },
    adaugaSerieNoua(id_firma) {
      this.$Progress.start();
      this.form_serii.post('api/cont/firma/serii_firma/' + id_firma)
        .then((response) => {
          toast.fire({
            icon: 'success',
            title: 'Serie adaugata!'
          })
          this.incarcaSeriiFirma(id_firma);
          this.$Progress.finish();
        })
        .catch((error) => {
          this.$Progress.fail()
          if (error.response.data.error) {
            this.eroare_add_serie = error.response.data.error;
          }
          toast.fire({
            icon: 'warning',
            title: 'Eroare la adăugarea seriei!'
          })
        })
    },
    editeazaSerie(id_firma, id_serie) {
      this.$Progress.start();
      this.form_serii.put('api/cont/firma/serii_firma/' + id_firma + '/' + id_serie)
        .then((response) => {
          toast.fire({
            icon: 'success',
            title: 'Serie actualizata!'
          })
          this.incarcaSeriiFirma(id_firma);
          this.$Progress.finish();
        })
        .catch((error) => {
          //console.log(errors.response.data.error);
          this.$Progress.fail();
          if (error.response.data.error) {
            this.eroare_add_serie = error.response.data.error;
          }
          toast.fire({
            icon: 'warning',
            title: 'Eroare la actualizarea seriei!'
          })
        })
    },
    stergeSeria(id_firma, id_serie) {
      this.$swal.fire({
        title: 'Ești sigur?',
        text: 'Această acțiune este ireversibilă!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmă ștergerea',
        cancelButtonText: 'Anulează'
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`/api/cont/firma/serii_firma/${id_serie}`)
            .then((response) => {
              toast.fire({
                icon: 'success',
                title: response.data.message || 'Seria a fost ștearsă cu succes.'
              });
              //this.incarcaSeriiFirme(id_firma); // Reîncarcă tabelul
              this.incarcaSeriiFirma(id_firma);
            })
            .catch((error) => {
              const mesaj = error.response?.data?.error || error.message || 'Eroare la ștergere.';
              toast.fire({
                icon: 'error',
                title: mesaj
              });
            });
        }
      });
    },
    async incarcaSeriiFirma(id_firma) {
      try {
        const response = await axios.get(`/api/cont/firma/serii_firma/${id_firma}`);
        this.lista_serii = response.data.serii;
      } catch (error) {
        console.error("Eroare la încărcarea seriilor:", error);
      }
    },
    modalEditareFirma(id) {
      this.editmode = true;
      this.form.reset();
      this.form.fill(id);
      this.form.tara = id.tara !== undefined && id.tara !== null && id.tara !== '' ? String(id.tara) : '';
      this.form.judet = id.judet !== undefined && id.judet !== null && id.judet !== '' ? String(id.judet) : '';
      this.form.localitate = id.localitate !== undefined && id.localitate !== null && id.localitate !== '' ? String(id.localitate) : '';
      this.form.stare_firma = Number(id.stare_firma ?? 0);
      this.incarcaTari();
      this.incarcaJudete(id.tara);
      this.incarcaLocalitati(id.judet);
      this.form.activ = id.activ === 1 || id.activ === true;
      this.form.conturi_bancare = (id.conturi_bancare || []).map(c => ({
        vizibil: c.vizibil === 1 || c.vizibil === true,
        iban: c.iban || '',
        banca: c.banca || ''
      }));
      this.form.puncte_lucru = (id.puncte_lucru || []).map(p => ({
        vizibil: p.vizibil === 1 || p.vizibil === true,
        adresa: p.adresa || '',
        telefon_contact: p.telefon_contact || '',
        fax: p.fax || '',
        persoana_contact: p.persoana_contact || ''
      }));
      // Adaugă afișarea siglei în preview dacă există
      if (id.sigla) {
        axios.get(`/api/fisiere/sigla-firma/${id.id}`, { responseType: 'blob' })
          .then(response => {
            this.previewUrl = URL.createObjectURL(response.data);
          })
          .catch(() => {
            this.previewUrl = null;
          });
      } else {
        this.previewUrl = null;
      }
      (this._modalFirma || (this.$refs.modalFirma && Modal.getOrCreateInstance(this.$refs.modalFirma)))?.show();
    },
    adaugaFirma() {
      this.$Progress.start();
      // Ensure scp_tva is integer
      this.form.scp_tva = this.form.scp_tva ? 1 : 0;
      this.form.post('/api/cont/adaugaFirma')
        .then((response) => {
          if (response.data && (response.data.success === true || response.data.id)) {
            toast.success
              ? toast.success('Firma a fost adăugată cu succes!')
              : toast.fire({ icon: 'success', title: 'Firma a fost adăugată cu succes!' });
            document.getElementById('modalFirmaClose')?.click();
            this.incarcaFirmeleMele();
          } else {
            toast.fire({ icon: 'success', title: 'Firma adăugată cu succes!' });
          }

          const idFirma = response.data.id;

          emitter.emit('AfterCreate');
          this.$Progress.finish();

          // După ce firma a fost adăugată, încercăm să adăugăm sigla (dacă există),
          // dar nu tratăm eșecul ca pe o eroare de adăugare firmă.
          if (this.form_sigla.sigla) {
            this.form_sigla
              .post('/api/cont/adaugaFirmaLogo/' + idFirma)
              .then(() => {
                console.log('Sigla încărcată cu succes.');
                axios
                  .get(`/api/fisiere/sigla-firma/${idFirma}`, { responseType: 'blob' })
                  .then((response) => {
                    this.previewUrl = URL.createObjectURL(response.data);
                  });
              })
              .catch(() => {
                console.warn('Eroare la încărcarea siglei.'); // nu afișăm toast de eroare
              });
          }
        })
        .catch((error) => {
          this.$Progress.fail();
          const msg = error.response?.data?.message || error.message || 'Eroare necunoscută';
          toast.fire({
            icon: 'warning',
            title: 'Eroare la adăugarea firmei!',
            text: msg,
          });
        });
    },
    actualizeazaFirma(id) {
      this.$Progress.start();
      // Ensure scp_tva is integer
      this.form.scp_tva = this.form.scp_tva ? 1 : 0;
      this.form.put('/api/cont/actualizeazaFirma/' + id)
        .then(() => {
          swal.fire({
            icon: 'success',
            title: 'Firmă actualizată!',
          })

          if (this.form_sigla.sigla) {
            this.form_sigla.post('/api/cont/adaugaFirmaLogo/' + id)
              .then(() => {
                console.log('Sigla încărcată cu succes.');
                axios.get(`/api/fisiere/sigla-firma/${id}`, { responseType: 'blob' })
                  .then(response => {
                    this.previewUrl = URL.createObjectURL(response.data);
                  });
              })
              .catch(() => {
                console.warn('Eroare la încărcarea siglei.');
              });
          }
          emitter.emit('AfterCreate');
          this.$Progress.finish();
        })
        .catch(() => {
          this.$Progress.fail();
          toast.fire({
            icon: 'warning',
            title: 'Eroare la actualizarea firmei!'
          })
        });
    },
    adaugaCont() {
      this.form.conturi_bancare.push({ vizibil: true, iban: '', banca: '' });
    },
    stergeCont(index) {
      this.form.conturi_bancare.splice(index, 1);
    },
    adaugaPunct() {
      this.form.puncte_lucru.push({ vizibil: true, adresa: '', telefon_contact: '', fax: '', persoana_contact: '' });
    },
    stergePunct(index) {
      this.form.puncte_lucru.splice(index, 1);
    },
    incarcaTari() {
      axios.get('/api/utils/taris2')
        .then((response) => {
          const arr = Array.isArray(response.data) ? response.data : [];
          this.tari = arr.map(opt => ({ id: String(opt.id ?? opt.value ?? ''), text: String(opt.text ?? opt.denumire ?? opt.nume ?? '') }));
        });
    },
    incarcaJudete(taraId) {
      if (!taraId) return this.judete = [];
      axios.get(`/api/utils/judetes2/${taraId}`)
        .then((response) => {
          const arr = Array.isArray(response.data) ? response.data : [];
          this.judete = arr.map(opt => ({ id: String(opt.id ?? opt.value ?? ''), text: String(opt.text ?? opt.denumire ?? opt.nume ?? '') }));
        });
    },
    incarcaLocalitati(judetId) {
      if (!judetId) return this.localitati = [];
      axios.get(`/api/utils/localitatis2/${judetId}`)
        .then((response) => {
          const arr = Array.isArray(response.data) ? response.data : [];
          this.localitati = arr.map(opt => ({ id: String(opt.id ?? opt.value ?? ''), text: String(opt.text ?? opt.denumire ?? opt.nume ?? '') }));
        });
    },
    deschideModalSeriiFirma(firmaId) {
      axios.get(`/api/firma/${firmaId}/serii`)
        .then((response) => {
          this.seriiFirma = response.data;
          (this._modalSerii || (this.$refs.modalSerii && Modal.getOrCreateInstance(this.$refs.modalSerii)))?.show();
        });
    },
    adaugaSerieFirma() {
      axios.post('/api/firma/adauga-serie', this.formSerie)
        .then(() => {
          toast.fire({ icon: 'success', title: 'Serie adăugată cu succes!' });
          this.formSerie = { denumire: '', tip_document: '', serie: '', numar_curent: 1 };
          this.deschideModalSeriiFirma(this.form.id);
        });
    }
  },
  computed: {
  },

  mounted() {
    this.setari_select2.dropdownParent = this.$refs.modalFirma;

    // cache Bootstrap modal instances
    if (this.$refs.modalFirma) this._modalFirma = Modal.getOrCreateInstance(this.$refs.modalFirma)
    if (this.$refs.modalSerii) this._modalSerii = Modal.getOrCreateInstance(this.$refs.modalSerii)
    if (this.$refs.modalUtilizatori) this._modalUtilizatori = Modal.getOrCreateInstance(this.$refs.modalUtilizatori)

    //this.$nextTick(() => this.initKTMenus());
  },
  activated() {
    this.$nextTick(() => this.initKTMenus());
    this.$nextTick(() => this.initDataTable());
    this.$nextTick(() => this.fallbackInitRowMenus());
    this.$nextTick(() => this.bindGlobalMenuDismiss());
  },
  unmounted() {
    if ($.fn.DataTable && $.fn.DataTable.isDataTable('#tabel_firme')) {
      $('#tabel_firme').DataTable().destroy();
    }
    // Unbind global handlers for fallback menus
    if (this._docClickHandler) { document.removeEventListener('click', this._docClickHandler, true); this._docClickHandler = null }
    if (this._escKeyHandler) { document.removeEventListener('keydown', this._escKeyHandler, true); this._escKeyHandler = null }
    this._menuDismissBound = false
    this._openFallbackMenus = []
  },
  created() {
    //var vm = this;
    this.incarcaFirmeleMele();

    emitter.on('AfterCreate', () => {
      if ($.fn.DataTable && $.fn.DataTable.isDataTable('#tabel_firme')) {
        $('#tabel_firme').DataTable().destroy();
      }
      this.incarcaFirmeleMele();
    });
  },

}
</script>


<style lang="scss" scoped>
.icon-mare {
  font-size: 24px
}

.modal-custom-width {
  max-width: 85% !important;
}
</style>